export default "__VITE_ASSET__Bit42$F9__"